/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {LegalEntityParentCompanyDTO} from '../model/LegalEntityParentCompanyDTO';
import {LegalEntitySubsidiaryDTO} from '../model/LegalEntitySubsidiaryDTO';
import {LegalEntitySubsidiaryPostRequestDTO} from '../model/LegalEntitySubsidiaryPostRequestDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* LegalEntitySubsidiaryServices service.
* @module api/LegalEntitySubsidiaryServicesApi
* @version v0
*/
export class LegalEntitySubsidiaryServicesApi {

    /**
    * Constructs a new LegalEntitySubsidiaryServicesApi. 
    * @alias module:api/LegalEntitySubsidiaryServicesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the deleteLegalEntitySubsidiaryById operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~deleteLegalEntitySubsidiaryByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete Legal Entity Subsidiary
     * Request to delete a Legal Entity Subsidiary given the id.
     * @param {Number} legalEntitySubsidiaryId 
     * @param {module:api/LegalEntitySubsidiaryServicesApi~deleteLegalEntitySubsidiaryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteLegalEntitySubsidiaryById(legalEntitySubsidiaryId, callback) {
      
      let postBody = null;
      // verify the required parameter 'legalEntitySubsidiaryId' is set
      if (legalEntitySubsidiaryId === undefined || legalEntitySubsidiaryId === null) {
        throw new Error("Missing the required parameter 'legalEntitySubsidiaryId' when calling deleteLegalEntitySubsidiaryById");
      }

      let pathParams = {
        'legalEntitySubsidiaryId': legalEntitySubsidiaryId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary/{legalEntitySubsidiaryId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAllLegalEntitySubsidiaries operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~getAllLegalEntitySubsidiariesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/LegalEntitySubsidiaryDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of all the Legal Entity Subsidiaries
     * Request to get a list of all the Legal Entity Subsidiaries
     * @param {module:api/LegalEntitySubsidiaryServicesApi~getAllLegalEntitySubsidiariesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllLegalEntitySubsidiaries(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [LegalEntitySubsidiaryDTO];

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getLegalEntitySubsidiaryById operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~getLegalEntitySubsidiaryByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LegalEntitySubsidiaryDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Legal Entity Subsidiary by id
     * Request to get a Legal Entity Subsidiary by its id.
     * @param {Number} legalEntitySubsidiaryId 
     * @param {module:api/LegalEntitySubsidiaryServicesApi~getLegalEntitySubsidiaryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getLegalEntitySubsidiaryById(legalEntitySubsidiaryId, callback) {
      
      let postBody = null;
      // verify the required parameter 'legalEntitySubsidiaryId' is set
      if (legalEntitySubsidiaryId === undefined || legalEntitySubsidiaryId === null) {
        throw new Error("Missing the required parameter 'legalEntitySubsidiaryId' when calling getLegalEntitySubsidiaryById");
      }

      let pathParams = {
        'legalEntitySubsidiaryId': legalEntitySubsidiaryId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = LegalEntitySubsidiaryDTO;

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary/{legalEntitySubsidiaryId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getLegalEntitySubsidiaryMonitor operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~getLegalEntitySubsidiaryMonitorCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/LegalEntityParentCompanyDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get monitor of Legal Entity Subsidiary
     * Request to get the list of all the Legal Entity Subsidiaries with the respective Legal Entity Parent Company.
     * @param {module:api/LegalEntitySubsidiaryServicesApi~getLegalEntitySubsidiaryMonitorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getLegalEntitySubsidiaryMonitor(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [LegalEntityParentCompanyDTO];

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary/monitor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the newLegalEntitySubsidiary operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~newLegalEntitySubsidiaryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create new Legal Entity Subsidiary
     * Request to add a new Legal Entity Subsidiary.
     * @param {module:model/LegalEntitySubsidiaryPostRequestDTO} body 
     * @param {module:api/LegalEntitySubsidiaryServicesApi~newLegalEntitySubsidiaryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    newLegalEntitySubsidiary(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling newLegalEntitySubsidiary");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateLegalEntitySubsidiaryById operation.
     * @callback moduleapi/LegalEntitySubsidiaryServicesApi~updateLegalEntitySubsidiaryByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Legal Entity Subsidiary
     * Request to update Legal Entity Subsidiary
     * @param {module:model/LegalEntitySubsidiaryPostRequestDTO} body 
     * @param {Number} legalEntitySubsidiaryId 
     * @param {module:api/LegalEntitySubsidiaryServicesApi~updateLegalEntitySubsidiaryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateLegalEntitySubsidiaryById(body, legalEntitySubsidiaryId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateLegalEntitySubsidiaryById");
      }
      // verify the required parameter 'legalEntitySubsidiaryId' is set
      if (legalEntitySubsidiaryId === undefined || legalEntitySubsidiaryId === null) {
        throw new Error("Missing the required parameter 'legalEntitySubsidiaryId' when calling updateLegalEntitySubsidiaryById");
      }

      let pathParams = {
        'legalEntitySubsidiaryId': legalEntitySubsidiaryId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-subsidiary/{legalEntitySubsidiaryId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}